<template>
  <div class="edu-home content-430">
    <div class="search-wrapper header-wrapper-430">
      <Form
        ref="searchForm"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem label="">
            <Input
              v-model.trim="listParams.insOrderId"
              placeholder="请输入退款单号"
              class="search-input-430"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="">
            <Input
              v-model.trim="listParams.relOrderId"
              placeholder="请输入订单号"
              class="search-input-430"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="">
            <Input
              v-model.trim="listParams.studentName"
              placeholder="学生姓名"
              class="search-input-430"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="">
            <Input
              v-model.trim="listParams.offerName"
              placeholder="课程名称"
              class="search-input-430"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="listParams.refundCheckSts"
              placeholder="请选择退款审批状态"
              clearable
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in refundCheckStsList"
                :key="index"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="listParams.refundSts"
              placeholder="请选择退款状态"
              clearable
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in refundStsList"
                :key="index"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="listParams.isSchoolCourse"
              placeholder="请选择课程类型"
              clearable
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in isSchoolCourseList"
                :key="index"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTermsRef"
              :placeholder="`请选择学期`"
              :clearable="true"
              :cache-year-terms="initYear"
              @on-init="onInitYearTerms"
              @on-change="getNewYearAndTerm"
            >
            </CascaderYearTerms>
          </FormItem>
          <FormItem class="sch-form-item" label="">
            <RemoteSelect
              v-if="portOrg == 0 || portOrg == 1"
              v-model="listParams.schoolId"
              :placeholder="portOrg == 2 ? userInfo.orgName : '请选择学校'"
              :remote-method="remoteGetSchoolList"
              :loading="loadingSchool"
              @clear="remoteGetSchoolList('')"
              @change="getSelectOption"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="(item, index) in schoolIdList"
                :key="index"
                :label="item.name"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
            <span v-if="portOrg == 2 || portOrg == 3">{{
              userInfo.orgName
            }}</span>
          </FormItem>
          <FormItem v-if="portOrg != 3" label="">
            <RemoteSelect
              v-model="listParams.orgId"
              placeholder="请选择机构"
              :remote-method="getListOrgOpeEduSch"
              :loading="loadingOrg"
              @clear="getListOrgOpeEduSch('')"
              @visible-change="loadAllOrgList"
            >
              <el-option
                v-for="(item, index) in orgIdList"
                :key="index"
                :label="item.orgName"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem v-if="showCanOperateData" label="">
            <Input
              v-model.trim="listParams.batchRefundId"
              placeholder="请输入退款批次ID"
              class="search-input-430"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="">
            <DatePicker
              v-model="listParams.createTimeStart"
              type="datetime"
              clearable
              transfer
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="退款创建开始时间"
              class="datePicker-430"
              @on-change="ontimeChange"
            ></DatePicker>
            <span class="marginlr-430">至</span>
            <DatePicker
              v-model="listParams.createTimeEnd"
              type="datetime"
              transfer
              clearable
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="退款创建结束时间"
              class="datePicker-430"
              @on-change="onendtimeChange"
            ></DatePicker>
          </FormItem>

          <FormItem label="">
            <DatePicker
              v-model="listParams.refundOperateTimeStart"
              type="datetime"
              clearable
              transfer
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="退款完成开始时间"
              class="datePicker-430"
              @on-change="ontimeChangeForOperate"
            ></DatePicker>
            <span class="marginlr-430">至</span>
            <DatePicker
              v-model="listParams.refundOperateTimeEnd"
              type="datetime"
              clearable
              transfer
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="退款完成结束时间"
              class="datePicker-430"
              @on-change="onendtimeChangeForOperate"
            ></DatePicker>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="listParams.refundReqType"
              placeholder="请选择退款申请渠道"
              class="search-daterange-430"
              clearable
            >
              <Option
                v-for="item in refundReqTypeList"
                :key="item.value"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="listParams.refundCycleMethod"
              placeholder="请选择退款周期方式"
              class="search-daterange-430"
              clearable
            >
              <Option
                v-for="item in refundCycleMethodList"
                :key="item.value"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button class="search-430" @click="handleReset">重置</Button>
        </Row>
      </Form>
      <div>
        <div class="table-title-special-430">
          <div class="flex align-items">
            <div class="flex align-items">
              <Spin v-show="spinCount"></Spin>
              待审批：<span style="margin-right: 8px; font-weight: bold">{{
                countInfo.waitAudit
              }}</span>
              退款申请数：<span style="margin-right: 8px; font-weight: bold">{{
                countInfo.refundNum
              }}</span>
              退款通过数：<span style="margin-right: 8px; font-weight: bold">{{
                countInfo.refundPass
              }}</span>

              已退款金额：<span style="margin-right: 8px; font-weight: bold">{{
                countInfo.refundFeeNum
              }}</span>
              待审批退款金额：<span
                style="margin-right: 8px; font-weight: bold"
              >{{ countInfo.waitingRefundAmount }}</span>
            </div>
          </div>
          <Button
            type="primary"
            class="search-430"
            @click="handleExportExcel"
          >导出Excel</Button>
        </div>
      </div>
    </div>
    <div class="table">
      <Table
        ref="selection"
        border
        :columns="columns12"
        :data="data6"
        :loading="loadingOrderList"
        :max-height="tableHeight"
        @on-selection-change="tableSelect"
      >
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>

        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>

        <template slot="chargeFee" slot-scope="{ row }">
          {{ row.chargeFee }}
        </template>
        <template slot="materialRefundCount" slot-scope="{ row }">
          {{ row.materialRefundCount ? row.materialRefundCount : '' }}
        </template>
        <template slot="courseRefundCount" slot-scope="{ row }">
          {{ row.courseRefundCount ? row.courseRefundCount : '' }}
        </template>
        <template slot="refundReqType" slot-scope="{ row }">
          {{ getRefundReqTypeStr(row.refundReqType) }}
        </template>

        <template slot="offerName" slot-scope="{ row }">
          <TablePoptip :content="row.offerName"> </TablePoptip>
        </template>

        <template slot="classTimeDesc" slot-scope="{ row }">
          <span v-if="row.refundType == '材料费'">--</span>
          <TablePoptip v-else :content="row.classTimeDesc" :show-poptips-content-length="30" :content-width="230"> </TablePoptip>
        </template>
        <template slot="refundCheckSts" slot-scope="{ row }">
          <!-- <span>新增退款审批</span> -->
          <!-- 退款审核状态 1: 退款待审核 2: 退款审批通过 3: 退款驳回 4: 已撤销 -->
          <span :class="refundCheckStsObj[row.refundCheckSts]">{{
            refundCheckStsStr[row.refundCheckSts]
          }}</span>
        </template>
        <template slot="refundSts" slot-scope="{ row }">
          <span :class="refundStsObj[row.refundSts]">{{
            refundStsStr[row.refundSts]
          }}</span>
        </template>
        <template slot="refundCycleMethod" slot-scope="{ row }">
          <span>{{
            refundCycleMethodObj[row.refundCycleMethod]
              ? refundCycleMethodObj[row.refundCycleMethod]
              : ''
          }}</span>
        </template>
        <template slot="createTime" slot-scope="{ row }">
          <span>{{ row.createTime || '--' }}</span>
        </template>
        <template slot="payTime" slot-scope="{ row }">
          <span>{{ row.payTime || '--' }}</span>
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <span
            class="action-btn"
            @click="handleShowRefundDetails(row, index)"
          >详情</span>
          <!-- v-auth="`REFUND_AUDIT`" -->
          <!-- 退款审核状态 1: 退款待审核 2: 退款审批通过 3: 退款驳回 4: 已撤销    eduAreaCode != '440114' -->
          <span
            v-if="
              configStatus === 1 &&
                +row.refundCheckSts !== 2 &&
                +row.refundCheckSts !== 3 &&
                +row.refundCheckSts !== 4 &&
                theUserIdentity !== 'org' &&
                theUserIdentity !== 'edu'
            "
            v-auth="`REFUND_AUDIT`"
            class="action-btn"
            @click="handleCheckRefund(row, index)"
          >
            审核
          </span>
          <!-- v-if="portOrg == 0 && row.refundSts == 0 && row.paySts == 3" -->
          <span
            v-if="
              +row.refundCheckSts === 1 &&
                theUserIdentity !== 'org' &&
                theUserIdentity !== 'edu'
            "
            v-auth="`REFUND_CANCEL`"
            class="action-btn"
            @click="handleCancelRefundOrder(row, index)"
          >
            撤销退款</span>
          <span
            v-if="
              +row.refundSts === 13 &&
                theUserIdentity === 'admin' &&
                !row.refundFailProcDesc
            "
            v-auth="`MANUAL_PROCESSING_REFUND_ADMIN`"
            class="action-btn"
            @click="handleMarkSign(row, index)"
          >
            手动处理</span>
          <span
            v-if="
              +row.refundSts === 13 &&
                theUserIdentity === 'school' &&
                !row.refundFailProcDesc
            "
            v-auth="`MANUAL_PROCESSING_REFUND_SCH`"
            class="action-btn"
            @click="handleMarkSign(row, index)"
          >
            手动处理</span>
        </template>
      </Table>
      <div class="page-wrap">
        <Page
          :total="pageInfo.count"
          show-total
          show-sizer
          :current="pageInfo.page"
          :page-size="pageInfo.size"
          :page-size-opts="pageSizeOpts"
          show-elevator
          @on-change="handlePageChange"
          @on-page-size-change="handlePageSize"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="showExportModal"
      title="正在导出"
      :mask-closable="false"
      @on-cancel="handleCancelExport"
    >
      <Progress :percent="percent" :stroke-width="5"></Progress>
      正在导出表格，请给我一些时间，请不要关闭当前页面！
      <div slot="footer">
        <Button @click="handleCancelExport">取消</Button>
      </div>
    </Modal>
    <RefundDrawerDetails
      ref="refundDetails"
      @refresh="getorgRefundOrderPage"
    ></RefundDrawerDetails>
  </div>
</template>

<script>
import { filterParams, getYuan, abs } from '@/utils/utils';
import { courseRefundOrderList } from '../assets/data/SchRefund';
import orderCenterApi from '@/request/orderCenter';
import { mapState, mapGetters, mapMutations } from 'vuex';
import RefundDrawerDetails from '@pv/orderCenter/assets/components/RefundDrawer/Details.vue';// 退款抽屉
import courseCenterApi from '@/request/courseCenter/index.js';
import courseCenterCenterApi from '@/request/courseCenter/courseCenterApi.js';
import axios from 'axios';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import RemoteSelect from '@c/RemoteSelect';
import educationAdmin from '@/request/educationAdmin/index.js';
import { changeDictionaries, refundStsList, refundCheckStsList } from '@/utils/dictionary.js';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import mixinTableHeight from '@/mixins/mixinTableHeight';
let IntervalId;
export default {
  name: 'FinanceRefundList',
  components: { RemoteSelect, RefundDrawerDetails, CascaderYearTerms },
  mixins: [mixinTableHeight],
  data() {
    return {
      initYear: [],
      refundSwitch: false,
      isShowDel: false,
      refundInfo: {},
      insOrderId: '',
      relOrderId: '',
      modal1: false,
      name: '订单管理',
      studentList: [],
      columns12: courseRefundOrderList,
      data6: [],
      pageInfo: {
        page: 1,
        count: 0,
        size: 10
      },
      pageSizeOpts: [10, 20, 50, 100],
      listParams: {
        orgId: '',
        insOrderId: '',
        studentId: '',
        relOrderId: '',
        paySts: '',
        createTimeStart: '',
        createTimeEnd: '',
        refundOperateTimeStart: '',
        refundOperateTimeEnd: '',
        offerName: '',
        batchRefundId: '',
        refundStsSet: '-1',
        refundCheckSts: '',
        refundSts: '',
        yearCode: '',
        termCode: '',
        refundReqType: '',
        refundCycleMethod: '',
        isSchoolCourse: ''
      },
      refundReqTypeList: [{
        value: '1',
        label: '家长端发起'
      }, {
        value: '2',
        label: '后台订单发起'
      }, {
        value: '3',
        label: '开班失败批量退款'
      }, {
        value: '4',
        label: '分班后批量退款'
      }, {
        value: '5',
        label: '请假可退款'
      }, {
        value: '6',
        label: '教务发起'
      }],
      loading: false,
      refundStsList: [...refundStsList], // 退款状态列表
      refundStsStr: changeDictionaries([...refundStsList]),
      refundCheckStsList: [...refundCheckStsList], // 退款审批状态
      refundCheckStsStr: changeDictionaries([...refundCheckStsList]),
      refundCycleMethodList: [
        {
          value: '1',
          label: '结算后退款'
        }, {
          value: '2',
          label: '未结算退款'
        }
      ], // 1=结算后退款，2=未结算退款
      refundCheckStsObj: {
        1: 'check-refund-430',
        2: 'passcheck-refund-430',
        3: 'stopcheck-refund-430',
        4: 'cancelcheck-refund-430'
      },
      refundStsObj: {
        11: 'has-refund',
        12: 'refund-ing',
        13: 'refund-err'
      },
      // 退款状态 11：已退款 12：退款处理中 13：退款失败
      payStsList: [

        {
          value: 3,
          label: '退款处理中'
        },
        {
          value: 4,
          label: '退款驳回'
        },
        {
          value: 5,
          label: '已退款'
        },
        {
          value: 6,
          label: '已撤销'
        }
      ],
      payStsArr: [
        '未支付', // 0
        '已支付', // 1
        '交易关闭', // 2
        '退款处理中', // 3
        '退款驳回', // 4
        '已退款', // 5
        '已撤销' // 6
      ],
      schoolList: [],
      selectData: [],
      actTypeList: [
        {
          value: 1,
          label: '已退款'
        },
        {
          value: 2,
          label: '驳回退款申请'
        }
      ],
      payTypeList: [
        {
          value: 1,
          label: '微信'
        },
        {
          value: 2,
          label: '微信'
        },
        {
          value: 3,
          label: 'POS机'
        },
        {
          value: 4,
          label: '银行汇款转账'
        },
        {
          value: 5,
          label: '支付宝转账'
        },
        {
          value: 6,
          label: '其他'
        }
      ],
      isSchoolCourseList: [
        {
          value: 1,
          label: '校内课程'
        }, {
          value: 2,
          label: '校外课程'
        }
      ],
      modalForm: {
        actType: '',
        refundFee: '',
        payType: '',
        remark: ''
      },
      backColumns: [
        {
          title: '退款金额',
          key: 'chargeFee',
          align: 'center'
        },
        {
          title: '退款状态',
          key: 'paySts',
          align: 'center'
        },
        {
          title: '退款时间',
          key: 'payTime',
          align: 'center'
        },
        {
          title: '退款备注',
          key: 'remark',
          align: 'center'
        }
      ],
      backData: [],
      isBack: true, // 是否退款
      modal: false,
      allMoney: '',
      isBackMoney: '',
      detailData: {},
      portOrg: -1, // 目前的哪个端 2：学校端 3：服务端
      checkRefundModal: {
        show: false,
        order: {}
      },
      loadingSchool: false,
      loadingOrg: false,
      schoolIdList: [],
      num: 0,
      percent: 0, // 上传进度条
      source: null,
      showExportModal: false,
      loadingOrderList: false,
      eduAreaCode: '',
      cancelRemark: '',
      cancelShow: false,
      isShowCancelBtn: false,
      screenOrgList: ['616367580986362377', '759869453063180289', '616367580986362378', '616367580986362407'],
      spinCount: false,
      countInfo: {
        waitAudit: '0', // 待审批
        refundNum: '0', // 退款申请数
        refundPass: '0', // 退款通过
        refundFeeNum: '0', // 已退款金额
        waitingRefundAmount: '0'// 待审批退款金额
      },
      orgIdList: [{ orgId: -1, orgName: '全部机构' }],
      firstGetTerm: true,
      configStatus: 0
    };
  },
  computed: {
    ...mapState(['theUserIdentity', 'userInfo']),
    ...mapGetters(['routeTitle']),
    showCanOperateData() {
      if (this.theUserIdentity === 'admin' || this.theUserIdentity === 'school' || this.theUserIdentity === 'org') {
        return true;
      } else {
        return false;
      }
    },
    showBatchBtn() {
      let flag = false;
      // 如果是正式环境的，那就只有花都区展示批量退款按钮
      if (process.env.NODE_ENV === 'production') {
        if (this.theUserIdentity === 'admin') {
          flag = true;
        } else if (this.theUserIdentity === 'school') {
          // && this.eduAreaCode == '440114'
          // 澳门测试学校、秀全外国语学校  (this.userInfo.orgId === '681611867042402304' || this.userInfo.orgId === '616367580986358035') this.eduAreaCode == '440114'
          flag = true;
        } else {
          flag = false;
        }
      } else {
        switch (this.theUserIdentity) {
          case 'admin':
          case 'school':
            flag = true;
            break;
          default:
            break;
        }
      }
      return flag;
    },
    refundCycleMethodObj() {
      return changeDictionaries([...this.refundCycleMethodList]);
    }
  },
  watch: {
    $route(to, from) {
      console.log('-----------');
      // 对路由变化作出响应
      //  this.getorgRefundOrderPage();
    },
    refundSwitch: function(newVal) {
      if (newVal === false) {
        this.insOrderId = '';
      }
    }
  },
  created() {
    // 首页待处理跳转进来待处理参数

    if (this.$route.query.refundCheckSts) {
      this.$set(this.listParams, 'refundCheckSts', Number(this.$route.query.refundCheckSts));
    }
    this.portOrg = localStorage.getItem('portOrg');
    // this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // 记住选择的课程提供方
    let schoolSelectList = {};
    const schoolSelect = JSON.parse(
      localStorage.getItem('refundSchoolSelectList')
    );
    if (schoolSelect) {
      schoolSelectList = schoolSelect;
    }
    if (
      (schoolSelectList.schoolId && this.portOrg === '0') ||
      (schoolSelectList.schoolId && this.portOrg === '1') ||
      (schoolSelectList.schoolId && this.portOrg === '3')
    ) {
      this.listParams.schoolId = schoolSelectList.schoolId || -1;
      this.localSchoolId = schoolSelectList.schoolId;
    }
    if (this.portOrg === '2') {
      this.getEduAreaName(this.userInfo.orgId);
      // 学校端
      this.listParams.schoolId = this.userInfo.orgId;
      this.initSchoolCanCheckRefund();
    } else {
      this.configStatus = 1;
    }
    // 首页进来
    if (this.$route.query.yearCode && this.$route.query.termCode) {
      this.initYear[0] = Number(this.$route.query.yearCode);
      this.initYear[1] = this.$route.query.termCode;
    }
    this.listParams.batchRefundId = this.$route.query.batchRefundId ? this.$route.query.batchRefundId : '';
    // this.getorgRefundOrderPage();
  },
  activated() {
    this.getorgRefundOrderPage();
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('FinanceRefundList');
    next();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    async initSchoolCanCheckRefund() {
      console.log('执行了查询的--------');
      const params = { schoolId: this.userInfo.orgId };
      const res = await courseCenterCenterApi.getApproveRefundDtoBySchoolIdApi(params);
      if (res.status == 200 && res.message) {
        this.configStatus = +res.message;
      }
    },
    // 获取统计信息
    async getOrderDataStatistics(params) {
      const data = JSON.parse(JSON.stringify(params));
      this.spinCount = true;
      // this.$Spin.show();
      const res = await orderCenterApi.getRefundOrderDataStatistics(data);
      this.spinCount = false;
      // this.$Spin.hide();
      if (res.status == 200) {
        for (const k in res.message) {
          if (['refundFeeNum', 'waitingRefundAmount'].includes(k)) {
            this.countInfo[k] = res.message[k] === null ? '0.00' : abs(res.message[k]);
          } else {
            this.countInfo[k] = res.message[k] === null ? 0 : res.message[k];
          }
        }
      }
    },
    loadAllOrgList(val) {
      if (!val) {
        this.getListOrgOpeEduSch('');
      }
    },
    // 搜索框 提供方
    async getListOrgOpeEduSch(orgName = '') {
      this.loadingOrg = true;
      const res = await orderCenterApi.getWxOrgList({
        pageNum: 1,
        pageSize: 100,
        orgType: ``,
        orgName,
        yearCode: this.listParams.yearCode,
        termCode: this.listParams.termCode
      });
      this.loadingOrg = false;
      if (res.status === 200) {
        const arr = [{ orgId: -1, orgName: '全部机构' }];
        this.orgIdList = [
          ...arr,
          ...res.message.list.map(item => {
            return { orgId: item.orgId, orgName: item.name || item.orgName };
          })
        ];
      }
    },
    // 搜索框 提供方
    async getListCourseOrderFun() {
      const res = await courseCenterApi.getCourseProviderList({
        passSts: 1
      });
      if (res.status === 200) {
        const arr = [{ orgId: -1, orgName: '全部机构' }];
        this.orgIdList = [
          ...arr,
          ...res.message.map(item => {
            return { orgId: item.orgId, orgName: item.name };
          })
        ];
      }
    },
    onInitYearTerms(yearTerms) {
      this.listParams.yearCode = '';
      this.listParams.termCode = '';
      if (yearTerms.length === 2) {
        this.listParams.yearCode = yearTerms[0];
        this.listParams.termCode = yearTerms[1];
      }
      this.getorgRefundOrderPage();
    },
    getNewYearAndTerm(yearTerms) {
      this.listParams.yearCode = '';
      this.listParams.termCode = '';
      if (yearTerms.length === 2) {
        this.listParams.yearCode = yearTerms[0];
        this.listParams.termCode = yearTerms[1];
      }
      if (this.portOrg === '0' || this.portOrg === '1') {
        // 运营0和教育局1
        this.getgoodSchoolListFun();
        this.listParams.orgId = -1;
        this.getListOrgOpeEduSch(); // 提供方
      }
      if (this.portOrg === '2') {
        this.listParams.orgId = -1;
        this.getListOrgOpeEduSch(); // 提供方
      }
      if (this.portOrg === '3') {
        // 机构
        this.listParams.orgId = this.userInfo.orgId;
        this.getgoodSchoolListFun();
      }
      if (this.firstGetTerm) {
        this.handleSearch();
        this.firstGetTerm = false;
      } else {
        this.portOrg !== 2 ? this.listParams.schoolId = -1 : '';
        this.portOrg !== 3 ? this.listParams.orgId = -1 : '';
      }
    },
    onYearTermsInit() {
      this.handleSearch();
    },
    async getEduAreaName(eduId) {
      const res = await educationAdmin.getEduAreaName({ eduId });
      if (res.status) {
        this.eduAreaCode = res.message.areaCode;
      }
    },
    // 去到批量退款页面
    handleToBatch() {
      this.$router.push({
        name: 'orderCenter_afterSale_schCourseRefund_batchRefundIndex'
      });
    },
    getSchoolId() {
      if (JSON.stringify(this.selectSchoolOption) === '{}') {
        return;
      }
      const obj = {
        schoolName: this.selectSchoolOption
          ? this.selectSchoolOption.label
          : '全部学校',
        schoolId: this.selectSchoolOption ? this.selectSchoolOption.value : -1
      };
      localStorage.setItem('refundSchoolSelectList', JSON.stringify(obj));
    },
    loadAllList(val) {
      if (!val) {
        this.remoteGetSchoolList('');
      }
    },
    // 动态搜索
    remoteGetSchoolList(query) {
      query ? (this.loadingSchool = true) : '';
      const queryTrue = query;
      if (this.portOrg === '0' || this.portOrg === '1') {
        // 运营0和教育局1
        this.getgoodSchoolListFun(queryTrue);
      }
      // if (this.portOrg === '3') {
      //   // 机构
      //   this.getMechanismSchoolListFun(queryTrue);
      // }
    },
    // 选中的项
    getSelectOption(id) {
      const option = this.schoolIdList.find(item => {
        return item.orgId === id;
      });
      this.selectSchoolOption = option;
      this.$forceUpdate();
    },
    // 搜索框 学校列表 运营端,教育局
    async getgoodSchoolListFun(query = '') {
      // const params = {};
      // !query ? (params.searchStr = '') : (params.searchStr = query);
      const res = await orderCenterApi.getWxOrgList({
        pageNum: 1,
        pageSize: 100,
        orgType: 1,
        orgName: query,
        yearCode: this.listParams.yearCode,
        termCode: this.listParams.termCode
      });
      this.loadingSchool = false;
      if (res.status === 200) {
        const arr = [{ orgId: -1, name: '全部学校' }];
        this.schoolIdList = [
          ...arr,
          ...res.message.list.map(item => {
            return { orgId: item.orgId, name: item.name || item.orgName };
          })
        ];
      }
    },
    // 请求学校列表(机构端)
    async getMechanismSchoolListFun(query) {
      const params = {
        pageNum: 1,
        pageSize: 1000
      };

      !query ? (params.searchStr = '') : (params.searchStr = query);
      const res = await courseCenterApi.getOrgSchoolListNew(params);
      if (res.status === 200) {
        const arr = [{ orgId: -1, name: '全部学校' }];
        this.schoolIdList = [
          ...arr,
          ...res.message.list.map(item => {
            return { orgId: item.schoolId, name: item.schoolName };
          })
        ];
      }
      this.loadingSchool = false;
    },
    // 点击显示退款单详情
    handleShowRefundDetails(row, index) {
      let tag = 'details';
      if (+row.refundCheckSts !== 2 && +row.refundCheckSts !== 3 && +row.refundCheckSts !== 4 && this.theUserIdentity !== 'org' && this.theUserIdentity !== 'edu') {
        tag = 'detailsForRefundNumCanChange';
      }
      this.$nextTick(() => {
        this.$refs.refundDetails.openDetailsDrawer(row, tag);
      });
    },
    // 创建开始时间选择
    ontimeChange(v) {
      this.listParams.createTimeStart = v;
    },
    ontimeChangeForOperate(v) {
      this.listParams.refundOperateTimeStart = v;
    },
    onendtimeChangeForOperate(v) {
      this.listParams.refundOperateTimeEnd = v;
    },
    // 创建结束时间选择
    onendtimeChange(v) {
      this.listParams.createTimeEnd = v;
    },
    // 分页
    handlePageChange(v) {
      this.pageInfo.page = v;
      this.getorgRefundOrderPage();
    },
    // 跳转第几页
    handlePageSize(pageSize) {
      this.pageInfo.size = pageSize;
      this.pageInfo.page === 1 && this.getorgRefundOrderPage();
    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.percent += 20;
      if (this.percent >= 80) {
        clearInterval(IntervalId);
      }
    },
    percentShow() {
      this.percent = 0;
      IntervalId = setInterval(this.percentShowFun, 500);
    },
    // 导出-进度条
    handleCancelExport() {
      this.source.cancel('取消请求');
    },
    // 导出退款订单excel
    async handleExportExcel() {
      // if (this.listParams.schoolId === -1 || this.listParams.schoolId === '') {
      //   this.$Message.error('请选择学校！');
      //   return;
      // }
      // if (this.theUserIdentity !== 'school' && (!this.listParams['createTimeStart'] || !this.listParams['createTimeEnd'])) {
      //   this.$Message.warning('请完善退款时间范围');
      //   return null;
      // }
      if ((this.listParams['createTimeStart'] && this.listParams['createTimeEnd']) && this.listParams['createTimeStart'] > this.listParams['createTimeEnd']) {
        this.$Message.error('退款创建结束时间必须大于退款创建开始时间');
        return null;
      }
      if ((this.listParams['refundOperateTimeStart'] && this.listParams['refundOperateTimeEnd']) && this.listParams['refundOperateTimeStart'] > this.listParams['refundOperateTimeEnd']) {
        this.$Message.error('退款完成结束时间必须大于退款完成开始时间');
        return null;
      }
      // const timeStampValue = this.theUserIdentity !== 'school' ? new Date(this.listParams.createTimeEnd).valueOf() - new Date(this.listParams.createTimeStart).valueOf() : 0;
      // if (this.theUserIdentity !== 'school' && timeStampValue > 31 * 24 * 60 * 60 * 1000) {
      //   this.$Message.warning('导出退款时间范围不得超过1个月');
      //   return null;
      // }

      // const paramsCopy = JSON.parse(JSON.stringify(this.listParams));
      const { isSchoolCourse, ...paramsOther } = this.listParams;
      const paramsCopy = JSON.parse(JSON.stringify(paramsOther));
      paramsCopy.schoolId === -1 ? (paramsCopy.schoolId = '') : '';
      paramsCopy.orgId === -1 ? (paramsCopy.orgId = '') : '';
      if (paramsCopy.refundStsSet == -1) {
        paramsCopy.refundStsSet = null;
      } else {
        paramsCopy.refundStsSet = paramsCopy.refundStsSet == 1 ? [0, -1] : [1, 2, 3, 4];
      }
      this.listParams.isSchoolCourse ? paramsCopy.offerOrgType = this.listParams.isSchoolCourse : '';
      const data = Object.assign({}, paramsCopy, {
        pageNum: 1,
        pageSize: 10000
        // orderType: 1 // 1:"课程订单"   2:"配餐订单"    3:"托管订单"
      });
      const params = filterParams(data);
      this.percentShow();
      this.showExportModal = true;
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      const res = await orderCenterApi.exportRefundOrderApi(params, this.source.token);
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(IntervalId);
            this.percent = 100;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(IntervalId);
            this.percent = 60;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            this.$Message.error({
              content: resData.error,
              duration: 5
            });
          }
        };
      } else {
        this.showExportModal = false;
      }
    },
    // 订单列表
    async getorgRefundOrderPage() {
      // const yearTerms = this.$refs.cascaderYearTermsRef.getResult();
      // this.listParams.yearCode = '';
      // this.listParams.termCode = '';
      // if (yearTerms.length > 1) {
      //   this.listParams.yearCode = yearTerms[0];
      //   this.listParams.termCode = yearTerms[1];
      // }
      const { isSchoolCourse, ...paramsOther } = this.listParams;
      const paramsCopy = JSON.parse(JSON.stringify(paramsOther));
      paramsCopy.schoolId === -1 ? (paramsCopy.schoolId = '') : '';
      paramsCopy.orgId === -1 ? (paramsCopy.orgId = '') : '';
      if (paramsCopy.refundStsSet == -1) {
        paramsCopy.refundStsSet = null;
      } else {
        paramsCopy.refundStsSet = paramsCopy.refundStsSet == 1 ? [0, -1] : [1, 2, 3, 4];
      }
      this.listParams.isSchoolCourse ? paramsCopy.offerOrgType = this.listParams.isSchoolCourse : '';
      const data = Object.assign({}, paramsCopy, {
        pageNum: this.pageInfo.page,
        pageSize: this.pageInfo.size
        // orderType: 1 // 1:"课程订单"   2:"配餐订单"    3:"托管订单"
      });
      const params = filterParams(data);
      this.getRefundOrderList(params);
      if (this.listParams.refundStsSet == 1) {
        this.isShowCancelBtn = true;
      } else {
        this.isShowCancelBtn = false;
      }
    },
    getRefundOrderList(params) {
      this.loadingOrderList = true;
      // this.$Spin.show();

      this.getOrderDataStatistics(params);
      orderCenterApi.getRefundOrderListApi(params).then(res => {
        if (res.status === 200) {
          this.pageInfo.count = Number(res.message.total);
          for (const key in res.message.list) {
            res.message.list[key]['payStsText'] = this.payStsFilter(
              res.message.list[key].paySts
            );
            res.message.list[key]['ordFee'] = getYuan(
              res.message.list[key].ordFee
            );
            res.message.list[key]['chargeFee'] = getYuan(
              res.message.list[key].chargeFee
            );
            res.message.list[key]['payTypeText'] = this.payTypeTextFilter(
              res.message.list[key].payType
            );
          }
          this.data6 = res.message.list;
        }
      }).finally(() => {
        // this.$Spin.hide();
        this.loadingOrderList = false;
      });
    },
    payTypeTextFilter(code) {
      var str = '';
      var obj = this.payTypeList.filter(val => {
        return val.value === code;
      });
      if (obj.length > 0) {
        str = obj[0].label;
      }
      return str;
    },
    // 获取订单状态
    payStsFilter(code) {
      var str = '';
      var obj = this.payStsList.filter(val => {
        return val.value === code;
      });
      if (obj.length > 0) {
        str = obj[0].label;
      }
      return str;
    },
    handleReset() {
      const { yearCode, termCode } = this.listParams;
      this.listParams = { yearCode, termCode };
      this.getorgRefundOrderPage();
    },
    handleSearch() {
      if (this.listParams.createTimeStart && this.listParams.createTimeEnd && (this.listParams.createTimeStart > this.listParams.createTimeEnd)) {
        this.$Message.error('退款创建结束时间必须大于退款创建开始时间');
        return false;
      }
      if (this.listParams.refundOperateTimeStart && this.listParams.refundOperateTimeEnd && (this.listParams.refundOperateTimeStart > this.listParams.refundOperateTimeEnd)) {
        this.$Message.error('退款完成结束时间必须大于退款完成开始时间');
        return false;
      }
      this.pageInfo.page = 1;
      this.getSchoolId();
      this.getorgRefundOrderPage();
    },
    tableSelect(v) {
      this.selectData = v;
    },
    // 退款审核 v1.2.2
    handleCheckRefund(row, index) {
      // this.$Message.warning('功能暂不可用');
      // return;
      // const idx = this.screenOrgList.findIndex(item => {
      //   return item === row.schoolId;
      // });
      // console.log(row, '是啥----');
      // if (idx !== -1) {
      //   this.$Message.error('功能暂不可用!');
      //   return;
      // }

      this.$nextTick(() => {
        this.$refs.refundDetails.openDetailsDrawer(row, 'refund');
      });
    },
    // 退款失败手工处理
    handleMarkSign(row, index) {
      // this.$Message.error('功能暂不可用!');
      // return;
      // const idx = this.screenOrgList.findIndex(item => {
      //   return item === row.schoolId;
      // });
      // if (idx !== -1) {
      //   this.$Message.error('功能暂不可用!');
      //   return;
      // }

      // this.$message.warning('功能暂不可用，请联系管理员');
      // return;
      this.$nextTick(() => {
        this.$refs.refundDetails.openDetailsDrawer(row, 'sign');
      });
    },
    handleCancleRefund() {
      this.checkRefundModal = {
        show: false,
        order: {}
      };
    },
    handleAgreeRefund() {
      this.checkRefundModal.type = 3;
      this.checkRefundModal.title = '退款确认';
    },
    // 撤销退款
    handleCancelRefundOrder(row, index) {
      // this.$Message.error('功能暂不可用!');
      // return;
      // const idx = this.screenOrgList.findIndex(item => {
      //   return item === row.schoolId;
      // });
      // if (idx !== -1) {
      //   this.$Message.error('功能暂不可用!');
      //   return;
      // }

      this.$Modal.confirm({
        title: '温馨提示',
        content: '是否撤销退款申请？确认该操作不可恢复。',
        onOk: () => {
          this.$nextTick(() => {
            this.cancelRefundOrder(row.insOrderId);
          });
        },
        onCancel: () => {

        }
      });
    },
    async cancelRefundOrder(insOrderId) {
      const res = await orderCenterApi.cancelRefundOrder({ insOrderId: insOrderId });
      if (res.status == 200) {
        this.$Message.success('撤销成功');
        this.getorgRefundOrderPage();
      }
    },
    getRefundReqTypeStr(type) {
      switch (String(type)) {
        case '1':
          return '家长端发起';
          break;
        case '2':
          return '后台订单发起';
          break;
        case '3':
          return '开班失败批量退款';
          break;
        case '4':
          return '分班后批量退款';
          break;
        case '5':
          return '请假可退款';
          break;
        case '6':
          return '教务发起';
          break;
      }
      return '--';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
.main-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.edu-home {
  // height: 100%;
  header {
    padding: 20px 20px 0 20px;
    background: #fff;
    margin-bottom: 20px;
    border-radius: 10px;
    box-shadow: 2px 2px 4px 2px #e8e8e8;
  }
  .btn {
    margin-right: 10px;
    width: 100px;
    text-align: center;
  }
  .main {
    margin-top: 20px;
    .table_title {
      width: 100%;
      line-height: 50px;
      position: relative;
      .btn_wrap {
        position: absolute;
        top: 0;
        right: 10px;
        button {
          margin-right: 10px;
        }
      }
      span {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
}
.backFee {
  margin-left: 10px;
  color: #5c45e5;
  cursor: pointer;
}
.page-wrap {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
/deep/.action-btn {
  margin-right: 5px;
  color: #1c7ffe;
  cursor: pointer;
}
/deep/.cancel-btn {
  margin-right: 5px;
  color: #ff7875;
  cursor: pointer;
}
/deep/.danger-btn {
  color: #fff;
  background-color: #ff7875;
  border-color: #ff7875;
}
.refund-model-content {
  .item {
    display: flex;
    margin-bottom: 10px;
    .item-left {
      width: 80px;
      text-align: right;
    }
    .item-right {
      flex: 1;
    }
  }
}
/deep/.ivu-table-fixed-shadow {
  height: auto !important;
}
.must {
  &:before {
    content: '*';
    display: inline-block;
    color: red;
  }
}

.passcheck-refund-430,
.check-refund-430,
.stopcheck-refund-430,
.cancelcheck-refund-430,
.has-refund,
.refund-err,
.refund-ing {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #444444;
  line-height: 14px;
  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
}
/* 审核中状态 */
.check-refund-430::before {
  background: rgb(64, 158, 255);
}
/* 审核通过状态 */
.passcheck-refund-430::before {
  background: rgb(25, 190, 107);
}
/* 审核驳回状态 */
.stopcheck-refund-430::before {
  background: rgb(255, 68, 68);
}
/* 审核撤销状态 */
.cancelcheck-refund-430::before {
  background: rgb(145, 0, 18);
}
/* 已退款 */
.has-refund::before {
  background: rgb(25, 190, 107);
}
/* 退款失败 */
.refund-err::before {
  background: rgb(255, 153, 0);
}
/* 退款中 */
.refund-ing::before {
  background: rgb(255, 153, 0);
}
</style>
